import { useAtom, useSetAtom } from "jotai";
import isEmpty from "lodash/isEmpty";
import { useMemo } from "react";
import { useProductSearchResults } from "../../features/search/hooks/useProductSearchResults";
import type { Search } from "../interfaces/Search";
import { initialSearchModuleState, SearchInputStoreMutate, SearchStore } from "../stores/search/search";

export function useSearchModule() {
  const [searchModule, setSearchModule] = useAtom(SearchStore);

  const { visible: isVisible, searchText } = searchModule;
  const isSearchEngineActive = isVisible || !isEmpty(searchText);
  const { results, loading } = useProductSearchResults(searchText, isSearchEngineActive);

  function hide() {
    setSearchModule({ ...searchModule, visible: false });
  }

  function reset(override?: Partial<Search.Input>) {
    setSearchModule({ ...initialSearchModuleState, ...override });
  }

  function clearSearch() {
    setSearchModule({ ...searchModule, searchText: "" });
  }

  function search(searchText: string) {
    setSearchModule({ ...searchModule, searchText });
  }

  return useMemo(
    function searchModule() {
      const module = { hide, searchText, isVisible, search, results, reset, loading, clearSearch };
      return module;
    },
    [isVisible, loading, results, searchText]
  );
}

export function useMutateSearch() {
  return useSetAtom(SearchInputStoreMutate);
}
